import {BaseContainerModel} from '../../base-container.model';
import {bl_wf_issue_label_hdr_RowClass} from '../../../dbschema/bl_wf_issue_label_hdr.model';

export class WfIssueLabelModel extends BaseContainerModel {
    bl_wf_issue_label_hdr: bl_wf_issue_label_hdr_RowClass = new bl_wf_issue_label_hdr_RowClass();
}
